"use strict";
/////////////////////////////////////////////
//                                         //
// Do not modify this file.                //
// This file is generated by WcfGenerator. //
//                                         //
/////////////////////////////////////////////
Object.defineProperty(exports, "__esModule", { value: true });
